import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/format";
import { Printer, Loader2 } from "lucide-react";

const ORDER = ["Bosna i Hercegovina", "Slovenija", "Austrija", "Njemačka", "Ostalo"];
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

function buildHtml(rows) {
  const today = formatDate(new Date().toISOString().slice(0, 10));
  const groups = ORDER.map((c) => [c, rows.filter((r) => (r.country || "Ostalo") === c)]).filter(([, l]) => l.length);
  const body = groups.map(([c, list]) => `
    <h2>${esc(c)} <span>(${list.length})</span></h2>
    <table><thead><tr><th style="width:28px">#</th><th style="width:34%">Kupac</th><th>Posao (komisija / model)</th><th style="width:110px">Rok isporuke</th></tr></thead>
    <tbody>${list.map((r, i) => `<tr><td>${i + 1}</td><td><b>${esc(r._name)}</b><div class="t">${esc(r.customer_type || "")}</div></td><td>${esc(r.title)}</td><td>${r._delivery ? formatDate(r._delivery) : "—"}</td></tr>`).join("")}</tbody></table>`).join("");
  return `<!doctype html><html><head><meta charset="utf-8"><title>Spisak naloga za proizvodnju</title><style>
    body{font-family:Arial,sans-serif;margin:24px;color:#111}h1{font-size:20px;margin:0}p.s{margin:4px 0 16px;color:#555;font-size:12px}
    h2{font-size:14px;margin:18px 0 6px}h2 span{color:#666;font-weight:normal}table{width:100%;border-collapse:collapse;font-size:12px}
    th,td{border:1px solid #999;padding:6px 8px;text-align:left;vertical-align:top}th{background:#eee}.t{color:#666;font-size:10px}
    tr{page-break-inside:avoid}</style></head><body>
    <h1>Spisak naloga u realizaciji — proizvodnja</h1><p class="s">Stanje na dan ${today} · ukupno ${rows.length} naloga</p>
    ${body || "<p>Nema naloga u realizaciji.</p>"}</body></html>`;
}

export default function ProductionListButton({ compute }) {
  const [busy, setBusy] = useState(false);
  const print = async () => {
    const win = window.open("", "_blank");
    if (!win) { toast.error("Dozvolite pop-up prozore za print"); return; }
    setBusy(true);
    try {
      const r = await api.get("/deals");
      const rows = r.data.map(compute).filter((d) => !d._invoiced && !d._transport)
        .map((d) => ({ ...d, _name: (d.customer_type === "Firma" ? d.company_name : d.customer_name) || d.company_name || d.customer_name || "—" }))
        .sort((a, b) => (a._delivery || "9999") < (b._delivery || "9999") ? -1 : (a._delivery || "9999") > (b._delivery || "9999") ? 1 : 0);
      win.document.write(buildHtml(rows));
      win.document.close();
      win.focus();
      setTimeout(() => win.print(), 300);
    } catch (e) {
      win.close();
      toast.error("Greška pri učitavanju naloga");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" size="sm" onClick={print} disabled={busy} data-testid="deals-production-print-btn">
      {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Printer className="h-4 w-4 mr-1.5" />} Spisak za proizvodnju
    </Button>
  );
}
